/**
 * Generates a CSV string from a 2d array.
 *
 * @param dataRows - 2d array of table data rows
 * @returns - csv string
 */
export function convertArrayToCsv(dataRows: string[][]): string {
  const lines: string[] = new Array(dataRows.length);
  for (let i = 0; i < dataRows.length; i++) {
    lines[i] = dataRows[i].join(',');
  }
  return lines.join('\n') + '\n';
}

/**
 * Returns a representation of the date in the date time string format ISO8601
 */
export function formatDateToISOString(dateValue: unknown) {
  if (dateValue instanceof Date) {
    return dateValue.toISOString();
  }
  if (isValidTimeStamp(dateValue)) {
    if (!isNaN(Number(dateValue))) {
      return new Date(Number(dateValue)).toISOString();
    }
    return new Date(dateValue as string).toISOString();
  }
}

/**
 * Checks if the date value entry is a valid timestamp
 * @returns true if the entry value is valid timestamp false if not.
 */
function isValidTimeStamp(dateValue: unknown): boolean {
  if (typeof dateValue === 'number') {
    return !!new Date(dateValue).getTime();
  } else if (typeof dateValue === 'string') {
    if (!isNaN(Number(dateValue))) {
      return !!new Date(Number(dateValue)).getTime();
    } else {
      return !!new Date(dateValue).getTime();
    }
  }
  return false;
}
